import { CampaignContainer, RootListsContainer, RootEmptyContainer } from './CampaignList.styles';
import { CampaignsPillId } from '@/modules/study-insights/types';
import { TFunction } from 'i18next';
import { ICampaign, Campaign } from '@/modules/study-insights/services/campaign';
import { Box, Loader } from '@/common/components';
import { loaderStyles } from '../../../shared/ParticipantLayout/ParticipantLayout.styles';
import CampaignPane from '../CampaignPane/CampaignPane';

interface Props {
  campaigns: Campaign[];
  selectedPill: CampaignsPillId;
  isLoading?: boolean;
  t: TFunction;
  onEditCampaign?: (campaign: ICampaign) => void;
  onOpenCampaignUrl?: (campaign: ICampaign) => void;
}

const getSelectedCampaigns = (
  selectedPill: CampaignsPillId,
  campaigns: Campaign[],
  t: TFunction,
): { campaigns: Campaign[]; dataTestId: string; emptyCopies: string } => {
  return {
    campaigns,
    dataTestId: selectedPill === CampaignsPillId.ACTIVE_CAMPAIGNS ? 'active-campaigns' : 'inactive-campaigns',
    emptyCopies:
      selectedPill === CampaignsPillId.ACTIVE_CAMPAIGNS
        ? t('campaign_list.no_active_campaigns')
        : t('campaign_list.no_inactive_campaigns'),
  };
};

const CampaignList = ({
  campaigns,
  selectedPill,
  isLoading,
  t,
  onEditCampaign,
  onOpenCampaignUrl,
}: Props): JSX.Element => {
  const selectedCampaigns = getSelectedCampaigns(selectedPill, campaigns, t);

  if (isLoading) {
    return (
      <Box>
        <Loader css={loaderStyles} />
      </Box>
    );
  }

  if (selectedCampaigns.campaigns.length === 0) {
    return <RootEmptyContainer>{selectedCampaigns.emptyCopies}</RootEmptyContainer>;
  }

  return (
    <RootListsContainer data-testid={selectedCampaigns.dataTestId}>
      {selectedCampaigns.campaigns.map((campaign) => (
        <CampaignContainer key={campaign.campaignID}>
          <CampaignPane
            campaign={campaign}
            key={campaign.campaignID}
            onCopy={() => (onOpenCampaignUrl ? onOpenCampaignUrl(campaign) : undefined)}
            onEdit={() => (onEditCampaign ? onEditCampaign(campaign) : undefined)}
          />
        </CampaignContainer>
      ))}
    </RootListsContainer>
  );
};

export default CampaignList;
